import { ModalManager } from "@iunctim/component-modal/Resources/Public/Scripts/components/ModalManager.js";

type DisplayState = { displayed: number; count: number };

/** Page-owned display policy. The stable modal ID remains the storage key. */
export class DisplayPolicy {
    private static initialized = new WeakSet<HTMLElement>();

    public static use(): void {
        document
            .querySelectorAll<HTMLElement>(
                '[scope="modal"][data-display="initial"]',
            )
            .forEach((element) => {
                if (this.initialized.has(element)) return;
                this.initialized.add(element);
                new DisplayPolicy(element).apply();
            });
    }

    public constructor(private element: HTMLElement) {}

    public apply(): void {
        const state = this.read();
        const now = Math.floor(Date.now() / 1000);
        const count = Number(this.element.dataset.displayCount || 0);
        const interval = Number(this.element.dataset.displayInterval ?? 86400);
        if (
            state &&
            ((count !== 0 && state.count >= count) ||
                state.displayed + interval >= now)
        )
            return;
        ModalManager.get(this.element).open();
        try {
            localStorage.setItem(
                this.element.id,
                JSON.stringify({
                    displayed: now,
                    count: (state?.count ?? 0) + 1,
                }),
            );
        } catch {
            // Dialogs still work when browser storage is unavailable.
        }
    }

    private read(): DisplayState | null {
        try {
            const value = JSON.parse(
                localStorage.getItem(this.element.id) ?? "null",
            );
            return value &&
                Number.isFinite(value.displayed) &&
                Number.isFinite(value.count)
                ? value
                : null;
        } catch {
            return null;
        }
    }
}
